// Feedback administration route (/admin/feedback, Admin): the status and kind filters and the open report in the URL; the screen is FeedbackAdminPage.
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { zFeedbackKind, zFeedbackStatus } from "@/api/__generated__/zod.gen";
import { optionalString } from "@/app/search";
import { FeedbackAdminPage } from "@/features/admin/feedback/FeedbackAdminPage";

const searchSchema = z.object({
  status: zFeedbackStatus.optional().catch(undefined),
  kind: zFeedbackKind.optional().catch(undefined),
  report: optionalString(),
});

export const Route = createFileRoute("/_app/admin/feedback")({
  validateSearch: searchSchema,
  staticData: { crumb: "Feedback" },
  component: FeedbackAdminPage,
});
